/* eslint-disable */
export default {

  ftype (name){
    var nameArr = name.split(".");
    return nameArr[nameArr.length-1].toLowerCase();
  },

  rnd_str (len) {
    len = len || 32;
    var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var maxPos = chars.length;
    var rstr = '';
    for (var i = 0; i < len; i++) {
      rstr += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return rstr;
  },

  uxToStr (uxtime) {
    var d = new Date(parseInt(uxtime) * 1000)
    // var year = d.getFullYear()
    var month = d.getMonth() + 1
    var day = d.getDate()
    // var hour = d.getHours()
    // var min = d.getMinutes()
    // var sec = d.getSeconds()
    return month + '月' + day + '日'
  },

  sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
      if ((new Date().getTime() - start) > milliseconds){
        break;
      }
    }
  },

  uxToYMD (uxtime) {
    var d = new Date(parseInt(uxtime) * 1000)
    var year = parseInt(d.getFullYear()) - 2000
    var month = d.getMonth() + 1
    var day = d.getDate()
    var hour = d.getHours()
    var min = d.getMinutes()
    // var sec = d.getSeconds()
    return year + '年' + month + '月' + day + '日';
  },

  uxToFull (uxtime) {
    var d = new Date(parseInt(uxtime) * 1000)
    var year = parseInt(d.getFullYear()) - 2000
    var month = d.getMonth() + 1
    var day = d.getDate()
    var hour = d.getHours()
    var min = d.getMinutes()
    // var sec = d.getSeconds()
    return year + '年' + month + '月' + day + '日' + hour + '时' + min + '分'
  },

  valid_cn_phone (phone) {
    if (phone.length === 11) {
      var pre_arr = ['139', '138', '137', '136', '135', '134', '159', '158', '157', '150', '151', '152', '188', '187', '182', '183', '184', '178', '147', '198', // china mobile
        '130', '131', '132', '156', '155', '186', '185', '145', '176', '175', '166', // china unicom
        '133', '153', '189', '180', '181', '177', '173', '199', // china telecom
        '170', // virtual 虚拟运营商
      ]
      return pre_arr.indexOf(phone.substring(0, 3)) > -1;
    }
    else{
      return false;
    }
  },

  valid_email(email) {
    var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return re.test(String(email).toLowerCase());
  },

  transitMsg (msg, interval) {
    var el = document.getElementById('mz_transitor')
    if (el != null) {
      return false
    }
    var _html = ''
    _html += '<div id="mz_transitor" class="in">' + msg + '</div>'
    document.getElementById('app_extra').innerHTML += _html
    this.adjustLeft()
    window.setTimeout(function () {
      el = document.getElementById('mz_transitor') // 存在原先未创建的情况
      el.classList.add('done')
      this.setTimeout(function () {
        el.parentNode.removeChild(el)
      }, 1000)
    }, interval)
  },

  adjustLeft () {
    var el = document.getElementById('mz_transitor')
    var boxWidth = el.offsetWidth
    // var _width = 1920
    // var _twidth = document.documentElement.clientWidth
    // if (_twidth > 1920) {
    //   _width = _twidth
    // }
    var _width = document.documentElement.clientWidth
    el.style.left = (_width - boxWidth) / 2 + 'px'
  },

  isMobile () {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  },

  getCookie (name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  }

}
